/* eslint-disable jsx-a11y/anchor-is-valid */
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import Link from 'next/link';
import styles from './trustedBadge.module.scss';
import LogoAddress from '../logoAddress/logoAddress';
import SmartImage from '../../smartImage/smartImage';

export default function TrustedBadge({
  logo = {
    path: '',
    alt: '',
    link: '/',
  },
  address = '595 Market Street, Suite 200<br>San Francisco, California 94105',
  cta = {},
  description = 'If you have special access needs and are having problems accessing this website, please call 833-536-3639.',
  images = [],
}) {
  return (
    <div className={styles.trustedBadge}>
      <LogoAddress logo={logo} address={address} cta={cta} />
      <div className={styles.right}>
        {description && (
          <div className={styles.description}>{parse(`${description}`)}</div>
        )}
        {images?.length > 0 && (
          <div className={styles.images}>
            {images?.map((image) =>
              image?.link ? (
                <Link key={image?.alt} href={image?.link}>
                  <SmartImage
                    src={image?.path}
                    priority
                    alt={image?.alt}
                    height={image.height}
                    width={image.width}
                  />
                </Link>
              ) : (
                <div key={image?.alt}>
                  <SmartImage
                    src={image?.path}
                    priority
                    alt={image?.alt}
                    height={image.height}
                    width={image.width}
                  />
                </div>
              )
            )}
          </div>
        )}
      </div>
    </div>
  );
}

TrustedBadge.propTypes = {
  logo: PropTypes.shape({
    path: PropTypes.string,
    alt: PropTypes.string,
    link: PropTypes.string,
  }),
  address: PropTypes.string,
  cta: PropTypes.shape({
    label: PropTypes.string,
    link: PropTypes.string,
  }),
  description: PropTypes.string,
  images: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string,
      alt: PropTypes.string,
      link: PropTypes.string,
    })
  ),
};
